import { AutoScaling } from 'aws-sdk';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
    },
    outsideEdge: {
        borderWidth: 3,
        borderColor: '#24909C',
        width: 115,
        height: 115,
        borderRadius: 70,
        alignSelf: 'center',
        marginTop: 20
    },
    contentBtn: {
        marginTop: '10%',
        flex: 1,
        paddingHorizontal: 25,
    },
    btn: {
        padding: 10,
        borderRadius: 30
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    innerEdge: {
        borderWidth: 10,
        borderColor: '#24909C',
        width: 100,
        height: 100,
        borderRadius: 50,
        alignSelf: 'center',
        marginTop: 4
    },
    imgMedal: {
        width: 48,
        height: 65.8,
        alignSelf: 'center',
        marginTop: 6
    },
    level: {
        fontSize: 25,
        fontWeight: '700',
        color: '#fff',
        alignSelf: 'center',
        position: 'absolute',
        top: 14
    },
    descriptionLevel: {
        marginTop: 20,
        fontWeight: '500',
        textAlign: 'center'
    },
    nextSteps: {
        textAlign: 'center',
        marginTop: 20,
        fontWeight: 'bold'
    },
    contentDescriptionNextSteps: {
        marginTop: 20
    },
    premiumBenefits: {
        textAlign: 'center',
        marginTop: 20,
        fontWeight: 'bold'
    },
    contentDescriptionPremiumBenefits: {
        marginTop: 20
    },
    contentTimeline: {
        marginTop: 20,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    stepConcluded: {
        width: 10,
        height: 10,
        borderRadius: 20,
        backgroundColor: '#24909C'
    },
    stepNoConcluded: {
        width: 10,
        height: 10,
        borderRadius: 20,
        borderColor: '#24909C',
        borderWidth: 1
    },
    stepLineConcluded: {
        borderWidth: 1,
        borderColor: '#24909C',
        width: 100,
        height: 2,
        marginTop: 4
    },
    stepLineNoConcluded: {
        borderStyle: 'dotted',
        borderWidth: 1,
        borderColor: '#24909C',
        width: 100,
        height: 2,
        marginTop: 4
    }
});

export default styles;
